// import { isPrivate } from '@/utils/env';
/**
 * 鉴权配置
 */

// 鉴权中转页url。
// 为什么要中转？——老webim中会在中转页监测是否在iframe中进行的鉴权，然后postMsg。
// 新版本不在中间页处理iframe逻辑了，但是为了保证和之前的逻辑尽量一致，因此保留了中间页。
export const AUTH_MIDDLE_PAGE = `${location.protocol}//${location.host}${location.pathname.replace(/\w+\.html/, 'sso-middle.html')}`;

/**
 * 鉴权配置。
 * 鉴权目前有以下这些场景和逻辑：
 * 1. commonAuth 通用鉴权。从第三方获得code之后，交给svr，svr将code送给第三方进行校验，然后返回实名的aid+d2.
 * 2. wx_mp 微信公众号。带code时从微信平台获取openid和匿名aid绑定，不带code时啥都不做。
 * 3. wx_mini 微信小程序。将传入的openid和匿名aid绑定。
 * 4. wx_qy ssc企微。将code等信息传入，从企微获得openid并绑定实名aid。
 * 5. wx_qy_qrcode 企微扫码。和wx_qy类似，只不过是扫码验证的。
 * 6. LingHang 广交会。整体逻辑类似通用鉴权。
 * 7. tencentSSO 腾讯官网鉴权
 * 整体上来看，wx_mp, wx_mini, wx_qy 这些，都可以统一起来，全部使用wx_qy的鉴权方式。
 * 但需要注意，wx_mp可以不传code。此时svr应放过。
 */
export default {
  // 通用 sso 授权配置。前端传入中间页url，svr根据客户的配置，将中间页拼接到回跳地址中返回给前端。
  commonAuth: {
    // 根据healthyan的说法，私有化里 commonAuth 和Saas的定义是不一样的。
    // 由于私有化占用了commonAuth，所以SaaS这里要重新命名一下这个参数。
    // commonAuthCredential就等价于老webim的commonAuth。
    // 5.8私有化中，不在做区分了，所以直接写死即可。
    name: 'commonAuthCredential', // isPrivate ? 'commonAuth' : 'commonAuthCredential',
    // 是否跳转到第三方获取code。变量名维持老webim的名字。
    ssoIframe: true,
    // 第三方鉴权返回后的地址
    // redirectUrl: AUTH_MIDDLE_PAGE,
    appType: 99,
  },
  // 公众号
  wx_mp: {
    name: 'wx_mp',
    ssoIframe: false,
    appType: 1,
  },
  // 小程序内置H5
  wx_mini: {
    name: 'wx_mini',
    ssoIframe: false,
    appType: 1,
  },
  // 废弃
  wx_mix: {
    name: 'wx_mix',
    ssoIframe: false,
    appType: 1,
  },
  // 企业微信
  wx_qy: {
    name: 'wx_qy',
    ssoIframe: false,
    appType: 19,
  },
  // 企业微信PC浏览器扫码登录
  wx_qy_qrcode: {
    name: 'wx_qy_qrcode',
    ssoIframe: false,
    appType: 19,
  },

  // ------------------- TODO: 三期需要实现 --------------------
  // 广交会-领航-测试
  // 相关文档： https://iwiki.woa.com/pages/viewpage.action?pageId=1381471967
  LingHangTEST: {
    name: 'LingHangTEST',
    appType: 6,
    ssoIframe: true,
    ssoIframeUrl:
                `/cgi-bin/oauth2/authorize?appid=438274603635200001&response_type=code&state=LingHangTEST&scope=clientapi_base&sid=448745233220476928&authCategory=BUYER&authTenantid=438274603635200000&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: AUTH_MIDDLE_PAGE,
    authDomain: 'it-blinkapi.cantonfair.org.cn',
    apiDomain: 'it-blinkapi.cantonfair.org.cn',
  },
  // 广交会-领航-测试 <-连-> webim线上
  LingHang: {
    name: 'LingHang',
    appType: 6,
    ssoIframe: true,
    ssoIframeUrl:
                `/cgi-bin/oauth2/authorize?appid=438274603635200001&response_type=code&state=LingHang&scope=clientapi_base&sid=448745233220476928&authCategory=BUYER&authTenantid=438274603635200000&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: AUTH_MIDDLE_PAGE,
    authDomain: 'it-blinkapi.cantonfair.org.cn',
    apiDomain: 'it-blinkapi.cantonfair.org.cn',
  },
  // 广交会-领航-压测
  LingHangPT: {
    name: 'LingHangPT',
    appType: 6,
    ssoIframe: true,
    ssoIframeUrl:
                `/cgi-bin/oauth2/authorize?appid=461435117139689472&response_type=code&state=LingHang&scope=clientapi_base&sid=465371950647181312&authCategory=BUYER&authTenantid=438274603635200000&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: AUTH_MIDDLE_PAGE,
    authDomain: 'pt-blinkapi.cantonfair.org.cn',
    apiDomain: 'pt-blinkapi.cantonfair.org.cn',
  },
  // 广交会-领航-正式
  LingHangOL: {
    name: 'LingHangOL',
    appType: 6,
    ssoIframe: true,
    ssoIframeUrl:
              `/cgi-bin/oauth2/authorize?appid=461101391566348288&response_type=code&state=LingHang&scope=clientapi_base&sid=463996009396080640&authCategory=BUYER&authTenantid=438274603635200000&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: AUTH_MIDDLE_PAGE,
    authDomain: 'blinkapi.cantonfair.org.cn',
    apiDomain: 'blinkapi.cantonfair.org.cn',
  },
  tencentSSO: {
    name: 'tencentSSO',
    ssoIframe: false,
  },
  commonAuthCredential: {
    name: 'commonAuthCredential',
    ssoIframe: false,
  },
  // 玲珑的测试环境
  LingLongTEST: {
    name: 'LingLongTEST',
    // getVidUrlKey: 'CHECK_THIRD_VISITORID',
    appType: 11,
    // needGetOpenid: false,
    // reconnectDoSso: true,
    ssoIframe: true,
    ssoIframeUrl: `/CustomerService.html?state=%257B%2522auth%2522%253A%2522LingLongTEST%2522%257D&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: 'https://webpage.qidian.qq.com/2/chat/sso-middle/index.html',
    authDomain: 'linglongdev.51autoshop.com',
  },
  LingLongUAT: {
    name: 'LingLongUAT',
    // getVidUrlKey: 'CHECK_THIRD_VISITORID',
    appType: 11,
    // needGetOpenid: false,
    // reconnectDoSso: true,
    ssoIframe: true,
    ssoIframeUrl: `/CustomerService.html?state=%257B%2522auth%2522%253A%2522LingLongUAT%2522%257D&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    // redirectUrl: 'https://webpage.qidian.qq.com/2/chat/sso-middle/index.html',
    authDomain: 'devshop.linglong.cn',
  },
  LingLong: {
    name: 'LingLong',
    getVidUrlKey: 'CHECK_THIRD_VISITORID',
    appType: 11,
    needGetOpenid: false,
    reconnectDoSso: true,
    ssoIframe: true,
    ssoIframeUrl: `/CustomerService.html?state=%257B%2522auth%2522%253A%2522LingLong%2522%257D&redirect_uri=${encodeURIComponent(AUTH_MIDDLE_PAGE)}`,
    redirectUrl: 'https://webpage.qidian.qq.com/2/chat/sso-middle/index.html',
    authDomain: 'sms.linglong.cn',
  },
  // 上海两会
  shOnline: {
    name: 'shOnline',
    getVidUrlKey: 'CHECK_THIRD_VISITORID',
    appType: 12,
    needGetOpenid: false,
    reconnectDoSso: true,
    ssoIframe: true,
    // ssoIframeUrl: '/user/oauth2/authorize/?app_id=a496bc60dcb7f7ba&type=app_admin&scope=user_base&state={"auth":"LingLong"}&account_id=a496bc60dcb7f7ba&redirect_uri=https://webpage.qidian.qq.com/2/chat/sso-middle/index.html',
    ssoIframeUrl: '/webim/sessionSH/wpaOpen?state=%257B%2522auth%2522%253A%2522shOnline%2522%257D&redirect_uri=https%3A%2F%2Fwebpage.qidian.qq.com%2F2%2Fchat%2Fsso-middle%2Findex.html',
    redirectUrl: 'https://webpage.qidian.qq.com/2/chat/sso-middle/index.html',
    authDomain: 'consolecgi.qidian.qq.com',
  },
};
